module.exports = __webpack_public_path__ + "img/linkedin.338f8f0a.svg";